// Where each existing page lives in the admin rail. Section ids come from the backend nav,
// which already applies permissions (level none hidden) and the not-built rule.
export const RAIL_GROUPS = [
  { id: "home", label: "Home", icon: "LayoutDashboard", pages: ["dashboard", "mm_overview", "mm_card", "mm_account", "mm_events", "mm_volunteering", "mm_messages", "mm_rewards", "mm_payments", "mm_give"] },
  { id: "membership", label: "Membership", icon: "Users", pages: ["membership_directory", "visitors", "contacts", "paused_removed", "incomplete_signups", "account_links", "codes_pins"] },
  { id: "gardens", label: "Gardens", icon: "Sprout", pages: ["gardeners", "garden_plots", "garden_hours", "reimbursements_queue"] },
  { id: "events", label: "Events", icon: "Calendar", pages: ["events", "calendar", "checkin"] },
  { id: "fundraising", label: "Fundraising & Sales", short: "Fundraising", icon: "HandCoins", pages: ["legacy_bricks", "merch_inventory", "merch_store", "donations", "grants", "fulfillment", "points_rewards"] },
  { id: "communications", label: "Communications", short: "Comms", icon: "Megaphone", pages: ["segments_sends", "targeted_messages", "requests_letters"] },
  { id: "governance", label: "Governance", icon: "Landmark", pages: ["board_meetings", "votes_approvals", "my_tasks", "board_roster", "partnerships", "reports"] },
  { id: "settings", label: "Settings", icon: "Settings", pages: ["roles_access", "dues_settings", "connections", "notification_settings", "modules", "brand_assets", "audit_log", "trash_reset", "view_member", "view_board"] },
];

// One page made of two existing sections, shown as tabs.
export const CODES_PINS = ["membership_codes", "member_pins"];
const LABELS = { reimbursements_queue: "Reimbursements", codes_pins: "Codes & PINs", view_member: "Member view", view_board: "Board view" };
const SLUGS = { membership_directory: "directory" };
const ACTIONS = { view_member: "general_member", view_board: "general_board_member" };

export const slugOf = (id) => SLUGS[id] || id;
export const idOfSlug = (slug) => Object.keys(SLUGS).find((k) => SLUGS[k] === slug) || slug;
export const pageOf = (id) => (CODES_PINS.includes(id) ? "codes_pins" : id);

// Builds [{group, items:[{id,label,icon,target,badge,persona}]}] from the person's nav.
export function buildRail(nav, { isSuper, badges = {} }) {
  const byId = Object.fromEntries(nav.map((n) => [n.id, n]));
  const placed = new Set();
  const groups = RAIL_GROUPS.map((g) => {
    const items = [];
    for (const pid of g.pages) {
      if (pid === "codes_pins") {
        const tabs = CODES_PINS.filter((t) => byId[t]);
        tabs.forEach((t) => placed.add(t));
        if (tabs.length) items.push({ id: "codes_pins", label: LABELS.codes_pins, icon: "KeyRound", target: tabs[0], badge: 0 });
      } else if (ACTIONS[pid]) {
        if (isSuper) items.push({ id: pid, label: LABELS[pid], icon: pid === "view_member" ? "User" : "Gavel", persona: ACTIONS[pid] });
      } else if (byId[pid]) {
        placed.add(pid);
        items.push({ ...byId[pid], label: LABELS[pid] || byId[pid].label, target: pid, badge: badges[pid] || 0 });
      }
    }
    return { ...g, items };
  });
  // Safety net: any page not listed above still gets a home in its own group (or Home).
  for (const n of nav) {
    if (placed.has(n.id)) continue;
    const g = groups.find((x) => x.id === n.group) || groups[0];
    g.items.push({ ...n, target: n.id, badge: badges[n.id] || 0 });
  }
  return groups.filter((g) => g.items.length);
}

export const groupOfTarget = (rail, id) => rail.find((g) => g.items.some((i) => i.target === id || (i.id === "codes_pins" && CODES_PINS.includes(id))));
